module.exports = __webpack_public_path__ + "static/media/19.df8d616a.JPG";